import { LOCALES } from "@marketplace/i18n";
export const pagenotfoundI18n = {
    [LOCALES.ENG]: {
        developer_404_header: 'Error 404 - Page Not Found',
        developer_404_blurb: "Well this is embarrasing. We couldn't find the page you're looking for. Please verify the URL is correct and try again. Or click below to return to the Home Page.",
        developer_404_button: 'Return to Home'
    }
};